import axios from 'axios'
import _ from 'lodash'

const CancelToken = axios.CancelToken;
let cancelMatchesRequest;

function getFilteredSearchFilters() {
  return axios.get('/api/filtered-search.json')
    .then(res => res.data)
}

function getGuidedSearchSteps() {
  return axios.get('/api/guided-search.json')
    .then(res => res.data)
}

function getFilteredSearchFiltersListByIds(ids = []) {
  return axios.post('/api/filtered-search/filter-list.json', { filter_terms: ids })
    .then(res => res.data)
}

function getMatches(activeFilterIds = [], currentPage = 1, perPage = 12 ) {
  // If there's a request in progress, cancel it
  // Docs: https://github.com/axios/axios#cancellation
  if (_.isFunction(cancelMatchesRequest)) {
    cancelMatchesRequest()
  }

  const params = {
    filter_terms: activeFilterIds,
    page: currentPage,
    per_page: perPage
  }

  const request = {
    method: 'post',
    url: '/api/search/tools.json',
    data: params,
    cancelToken: new CancelToken(c => cancelMatchesRequest = c)
  }

  return axios(request)
    .then(res => {
      if (!res.data.results.exact) {
        res.data.results.exact = []
      }
      if (!res.data.results.close) {
        res.data.results.close = []
      }

      return res.data
    })
    .catch(err => {
      // if (axios.isCancel(err)) {
      //   console.log('Request canceled', err.message)
      // }
      return err
    })
}

export default {
  getMatches,
  getFilteredSearchFilters,
  getFilteredSearchFiltersListByIds,
  getGuidedSearchSteps
}
